export default class magic {
  
  constructor() {

    let magic = document.querySelector('.magic');
    if (magic === null) return;

    let containerBanner = document.querySelector('.container-banner');
    let magicWHalf = magic.offsetWidth / 2;
  
    document.body.addEventListener('mousemove',function(e){
      magic.style.left = e.pageX - containerBanner.offsetLeft - magicWHalf+'px';
      magic.style.top = e.pageY - containerBanner.offsetTop - magicWHalf+'px';
    });
  }
}